import React, {useState, useEffect} from "react";
import { useNavigate, useParams } from "react-router-dom";
import './Dimenssions.css';
import axiosInstance from "../../../Config/axiosInstance";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Snackbar, Alert } from "@mui/material";

const EditDimenssions = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const[formData, setFormData] = useState({
        dimenssions: "",
    });

    //state-uri pentru validare si notificari
    const [dimensionError, setDimensionError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "", 
        severity: "error"
    });
    const [originalDimension, setOriginalDimension] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get(`/dimensions/${id}/`);
                setFormData(response.data);
                setOriginalDimension(response.data.dimenssions);
            } catch (error) {
                console.error("Error fetching dimenssions: ", error);
                setSnackbar({
                    open: true,
                    message: "Error loading dimension data.",
                    severity: "error"
                });
            }
        };
        fetchData();
    }, [id]);

    //functie pentru verificarea existentei dimensiunii
    const checkDimensionExists = async (dimenssion) => {
        if(!dimenssion.trim()) {
            return false;
        }

        try {
            const response = await axiosInstance.get("/dimensions/check-name/", {
                params: {dimenssions: dimenssion.trim()}
            });
            return response.data.exists;
        } catch (error) {
            console.error("Error checking dimension: ", error);
            return false;
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        //reseteaza eroarea cand utilizatorul modifica campul
        if(dimensionError) {
            setDimensionError("");
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({...snackbar, open: false});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        //prevenire submit multiplu
        if(isSubmitting) return;
        setIsSubmitting(true);

        try {
            //verificam doar daca dimensiunea a fost modificata
            if(formData.dimenssions !== originalDimension) {
                const dimensionExists = await checkDimensionExists(formData.dimenssions);
                
                if(dimensionExists) {
                    setDimensionError("This dimension already exists in the system!");
                    setSnackbar({
                        open: true,
                        message: "The dimension already exists. Please enter a unique dimension!",
                        severity: "error"
                    });
                    setIsSubmitting(false);
                    return;
                }
            }

            //daca dimensiunea nu exista sau nu a fost modificata, actualizam datele
            const response = await axiosInstance.put(`/dimensions/${id}/`, formData);
            console.log("Update successfully: ", response.data);

            //afisam un mesaj de succes
            setSnackbar({
                open: true,
                message: "The dimension was updated succesfully!",
                severity: "success"
            });

            //navigam inapoi dupa un scurt delay
            setTimeout(() => {
                navigate(-1);
            }, 1500);

        } catch(error) {
            console.error("Error updating dimenssions: ", error.response?.data || error.message);

            //verificam daca eroarea vine de la backend
            if(error.response?.status === 400) {
                const errorMessage = error.response?.data.dimenssion ||
                                    error.response?.data?.message || 
                                    "";
                
                if(errorMessage.includes("already exists") || 
                    errorMessage.includes("duplicate") || 
                    error.response?.data?.dimenssions?.includes("already exists")) {
                        setDimensionError("This dimension already exists in the system!");
                        setSnackbar({
                            open: true,
                            message: "The dimenssion already exists. Please enter a unique dimension!",
                            severity: "error"
                        });
                    }
                    else {
                        setSnackbar({
                            open: true,
                            message: "An error occurred while updating the dimension.",
                            severity: "error"
                        });
                    }
            } else {
                setSnackbar({
                    open: true,
                    message: "An error occured while updating the dimension.",
                    severity: "error"
                });
            }
            setIsSubmitting(false);
        }
    };  

    return (
        <>
        <div className="dimenssions-page">
        <div className="add-dimenssions-container">
            <div className="dimenssions-header">
                <ArrowBackIcon className="back-arrow" onClick={() => navigate(-1)} />
                <h2 className="add-materials-title">Edit Dimension</h2>
            </div>
        </div>

            <hr className="title-separator"/>
        
        <div className="add-dimenssions-container">
            <form onSubmit={handleSubmit} className="add-materials-form">
                <div className="form-group">
                    <label htmlFor="dimenssions" className="label">
                        Dimension<span className="required-star">*</span>
                    </label>
                    <input
                        id="dimenssions"
                        type="text"
                        name="dimenssions"
                        value={formData.dimenssions}
                        onChange={handleChange}
                        className="input"
                        required 
                    />
                    {dimensionError && (
                        <div className="error-message" style={{color: "#d32f2f", fontSize: '0.875rem'}}>
                            {dimensionError}
                        </div>
                    )}
                </div>
            
                <button 
                type="submit" 
                className="button-save"
                disabled={isSubmitting}
                >
                    {isSubmitting ? "Updating..." : "Update"}
                </button>
            </form>
        </div>
        </div>

        {/*snackbar pentru notificari*/}
        <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                sx={{width: '100%'}}
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
      </>  
    );
}

export default EditDimenssions;